import { safeJsonParse } from "../utils/commonutils";

export const fetchSessionData = (key) => {
  return sessionStorage.getItem(key);
}

export const storeSessionData = (key, value) => {
  sessionStorage.setItem(key, value);
}

export const removeSessionItem = (key) => {
  sessionStorage.removeItem(key)
}

export const clearSessionStorage = () => {
  sessionStorage.clear()
}

export const getSessionData = (key) => {
    return safeJsonParse(fetchSessionData(key));
}
export const setSessionData = (key, data) => {
    storeSessionData(key, JSON.stringify(data));
}
